import * as React from "react";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import Dashboard from "../page/Dashboard";
import Employee from "../page/Employee";
import EmployeeDetails from "../page/Employee/view";
import SocialImpact from "../page/SocialImpact";
import InviteUploadFile from "../page/InviteUploadFile";
import Login from "../page/Login";
import ForgetPassword from "../page/ForgetPassword";
import PrivateRoute from "./PrivateRoute";
import PublicRoute from "./PublicRoute";
import RoleBaseRoute from "./roleBaseRoute";
import ZeroTolerancePolicy from "../page/ZeroTolerancePolicy";
import OMWSupport from "../page/OMWSupport";
import Videos from "../page/Videos";
import CalendarSettings from "../page/CalendarSettings";

const Router = () => {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" Component={PrivateRoute}>
          <Route path="/" Component={Dashboard} />
        </Route>
        <Route path="/employee" Component={PrivateRoute}>
          <Route path="/employee" Component={Employee} />
        </Route>
        <Route path="/employee" Component={PrivateRoute}>
          <Route path="/employee/:id" Component={EmployeeDetails} />
        </Route>
        {/*<Route path="/company" Component={PrivateRoute}>*/}
        {/*  <Route path="/company" Component={Company} />*/}
        {/*</Route>*/}
        <Route path="/socialimpact" Component={PrivateRoute}>
          <Route path="/socialimpact" Component={SocialImpact} />
        </Route>
        <Route path="/inviteuploadfile" Component={PrivateRoute}>
          <Route path="/inviteuploadfile" Component={InviteUploadFile} />
        </Route>
        <Route path="/zerotolerancepolicy" Component={PrivateRoute}>
          <Route path="/zerotolerancepolicy" Component={ZeroTolerancePolicy} />
        </Route>
        <Route path="/omwsupport" Component={PrivateRoute}>
          <Route path="/omwsupport" Component={OMWSupport} />
        </Route>
        <Route path="/videos" Component={PrivateRoute}>
          <Route path="/videos" Component={Videos} />
        </Route>
        <Route path="/calendar-settings" Component={PrivateRoute}>
          <Route path="/calendar-settings" Component={CalendarSettings} />
        </Route>

        <Route path="*" Component={PrivateRoute}>
          <Route path="*" Component={RoleBaseRoute} />
        </Route>
        <Route path="/login" Component={PublicRoute}>
          <Route path="/login" Component={Login} />
        </Route>
        <Route path="/forgot-password" Component={PublicRoute}>
          <Route path="/forgot-password" Component={ForgetPassword} />
        </Route>
      </Routes>
    </BrowserRouter>
  );
};

export default Router;
